// removed by extract-text-webpack-plugin
module.exports = {"header":"_2qlei","title":"_1mfwT","subtitle":"krru5","bottomLeft":"_8vGZO","bottomRight":"_3Tuyc","iconButton":"_2U02s","infoButton":"_2wlz5 _2U02s","active":"_3CLjg","shareInfo":"_3vSMp","slider":"fzEBe","fixedIcon":"B9SIp","fixedTitle":"GYLzM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/album/AlbumHeader.css
// module id = 815
// module chunks = 0